import Projects from './Projects';
import './Projects.scss';

export default Projects;
